// 侧边栏是否收缩
import { observable, action, computed, toJS } from 'mobx'

class Bars {
  @observable collapsee = true

  @action
  async init () {
    let flag = localStorage.getItem('collapse')
    this.collapsee = flag === 'true'
  }

  @action
  toggle () {
    this.collapsee = !this.isCollapse
    localStorage.setItem('collapse', this.collapsee)
  }

  @computed
  get isCollapse () {
    return toJS(this.collapsee)
  }
}

export default new Bars()



// WEBPACK FOOTER //
// ./src/stores/bars.js